import {Component, Input, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.scss'],
    standalone: false
})
export class ModalComponent {
  @ViewChild('modal', {static: true}) modal;
  @ViewChild('closeButton', {static: true}) closeButton;
  @Input() title = 'Modal';
  @Input() toggle_id = 'modal';

  close() {
    this.closeButton.nativeElement.click();
  }
}
